/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_View_TicketInputs */

const en_btn_view_ticket = /** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Ticket`)
};

const es_btn_view_ticket = /** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Ticket`)
};

const fr_btn_view_ticket = /** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le ticket`)
};

const de_btn_view_ticket = /** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket ansehen`)
};

const id_btn_view_ticket = /** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Tiket`)
};

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const ja_btn_view_ticket = en_btn_view_ticket;

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const zh_btn_view_ticket = en_btn_view_ticket;

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const ar_btn_view_ticket = en_btn_view_ticket;

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const it_btn_view_ticket = en_btn_view_ticket;

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const ru_btn_view_ticket = en_btn_view_ticket;

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const pt_btn_view_ticket = en_btn_view_ticket;

/** @type {(inputs: Btn_View_TicketInputs) => LocalizedString} */
const ko_btn_view_ticket = en_btn_view_ticket;

/**
* | output |
* | --- |
* | "View Ticket" |
*
* @param {Btn_View_TicketInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const btn_view_ticket = /** @type {((inputs?: Btn_View_TicketInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_View_TicketInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_view_ticket(inputs)
	if (locale === "es") return es_btn_view_ticket(inputs)
	if (locale === "fr") return fr_btn_view_ticket(inputs)
	if (locale === "de") return de_btn_view_ticket(inputs)
	if (locale === "ja") return ja_btn_view_ticket(inputs)
	if (locale === "zh") return zh_btn_view_ticket(inputs)
	if (locale === "ar") return ar_btn_view_ticket(inputs)
	if (locale === "id") return id_btn_view_ticket(inputs)
	if (locale === "it") return it_btn_view_ticket(inputs)
	if (locale === "ru") return ru_btn_view_ticket(inputs)
	if (locale === "pt") return pt_btn_view_ticket(inputs)
	return ko_btn_view_ticket(inputs)
});